<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <v-title>预警列表 </v-title>
            <div class="content">
              <div class="closeDraw">
                <el-button icon="el-icon-close" @click="closeClick"></el-button>
              </div>
              <div class="tabPanel">
                <el-tabs v-model="activeName">
                  <!-- <el-tab-pane label="气象" name="first">
                    <ul class="el-timeline">
                      <li
                        v-for="(item, index) in weather"
                        :key="index"
                        class="el-timeline-item"
                        @click="handleqxClick(item)"
                      >
                        <div class="el-timeline-item__tail"></div>
                        <img :src="returnImg(item.isCheck)" class="node__img" />
                        <div class="el-timeline-item__wrapper">
                          <div class="el-timeline-item__timestamp is-top">
                            {{
                              $formatDate(
                                new Date(item.sendTime),
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            }}
                          </div>
                          <div class="el-timeline-item__content">
                            <div>
                              {{ item.sendContent }}
                            </div>
                          </div>
                          <div
                            class="el-timeline-item__timestamp is-bottom"
                          ></div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane> -->
                  <el-tab-pane label="设备" name="first">
                    <ul class="el-timeline">
                      <li
                        v-for="(item, index) in sbList"
                        :key="index"
                        class="el-timeline-item"
                      >
                        <div class="el-timeline-item__tail"></div>
                        <img :src="returnImg(item.isCheck)" class="node__img" />
                        <div class="el-timeline-item__wrapper">
                          <div class="el-timeline-item__timestamp is-top">
                            {{
                              $formatDate(
                                new Date(item.date),
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            }}
                          </div>
                          <div class="el-timeline-item__content">
                            <div>
                              {{ item.content }}
                            </div>
                          </div>
                          <div
                            class="el-timeline-item__timestamp is-bottom"
                          ></div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { getWlwWarningData } from "@/api/home";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeName: "first",
      list: [],
      weather: [],
      sbList: [],
    };
  },
  computed: {
    ...mapGetters(["rightComponentBak"]),
  },
  mounted() {
    // this.qxYjList(); //暂时无用到
    this.sbYjList();
  },
  methods: {
    closeClick() {
      this.$store.dispatch(
        "drawer/setRightComponent",
        this.rightComponentBak || "rightDrawer"
      );
    },

    sbYjList() {
      getWlwWarningData().then((res) => {
        this.sbList = res.data.map((e) => {
          e.content =
            e.wlwName + e.wlwCode + "监测到" + e.info + ",请注意查看和处理";
          e.isCheck = false;
          return e;
        });
      });
    },
    returnImg(isCheck) {
      if (isCheck) {
        return require("images/index/btnGroup/chose.png");
      } else {
        return require("images/index/btnGroup/node.png");
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
.content
  height calc(100% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.warn
  padding 0
  background transparent
  border 0
  color #fff
  font-size 0.18rem
  &:hover
    background transparent
    color #fff
.tabPanel
  height calc(100% - 0px)
  width calc(100% - 0px)
  >>>.el-tabs__content
    height calc(100% - 55px)
  >>>.el-tabs
    height 100%
  >>>.el-tabs__item
    color #fff
    font-size 0.08rem
  >>>.el-tabs__item.is-active
    color #0ff
  >>>.el-tabs__active-bar
    background-color #0ff
  >>>.el-tabs__nav-wrap::after
    background-color transparent
.el-timeline
  height 70vh
  overflow-y auto
  padding-top 5px
  li:hover
    cursor pointer
  .el-timeline-item__timestamp
    font-family 'electronicFont'
    font-size 0.08rem
    color #0ff
  .el-timeline-item__timestamp.is-top
    margin-bottom 5px
    padding-top 2px
  .el-timeline-item__content
    color #fff
    font-size 0.07rem
    letter-spacing 0.005rem
  .el-timeline-item__tail
    left 6px
    border-color #0ff
  .el-timeline-item__node--normal
    left 0
  .node__img
    position absolute
    left -5px
    top -6px
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #0ff
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.el-timeline-item
  color #fff
  padding-bottom 4px
.el-timeline-item__wrapper
  padding-left 18px
.el-timeline-item__content
  color $textColor
.el-timeline-item:last-child
  padding-bottom 4px
@media (min-width 1700px)
  .el-timeline
    height 80vh
@media (min-height 1400px)
  .content
    height calc(100% - 79px)
  .rightBar
    >>>.side
      width 24% !important
  .closeDraw
    top -60px
    right 20px
    .el-button
      font-size 40px
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .tabPanel>>>.el-tabs__item
    height 30px !important
    line-height 30px !important
  .tabPanel>>>.el-tabs__header
    margin 0 0 5px !important
  .el-timeline
    .el-timeline-item__timestamp
      font-size 0.11rem
    .el-timeline-item__content
      font-size 0.09rem
  .closeDraw
    top -20px
    .el-button
      font-size 15px
</style>
